import { Button } from 'components/Button'
import { Link } from 'components/Link'
import { useTranslation } from 'hooks/useTranslation'
import { FEEDING_COMPARISON_CTA_URL, FeedingType, getFeedingInfo } from '../feedingContent'
import {
  Badge,
  CtaWrapper,
  Description,
  FeedingInfoCardRoot,
  Headline,
} from './FeedingInfoCard.styles'

type FeedingInfoCardProps = {
  type: FeedingType
}

export const FeedingInfoCard = ({ type }: FeedingInfoCardProps) => {
  const { t } = useTranslation()
  const info = getFeedingInfo(t, type)

  return (
    <FeedingInfoCardRoot role="region" aria-live="polite">
      <Badge>{info.badge}</Badge>
      <Headline>{info.headline}</Headline>
      <Description>{info.description}</Description>
      <CtaWrapper>
        <Link href={FEEDING_COMPARISON_CTA_URL} passHref>
          <Button as="a" variant="primary" fullWidth>
            {t('blog:currently-feeding.create-meal-plan')}
          </Button>
        </Link>
      </CtaWrapper>
    </FeedingInfoCardRoot>
  )
}
